import React from "react";
import StyledNotification from "./StyledNotification";
import { IoIosClose } from "react-icons/io";

const styleProps = {
  background: "white",
  iconBackground: "#FF3B30"
};

const SuccessNotification = props => {
  return (
    <StyledNotification {...styleProps}>
      <div className="icon">
        <IoIosClose />
      </div>
      <div className="content">
        <div className="title">error!</div>
        <div className="text">{props.title}</div>
      </div>
      {/* <button onClick={() => props.close(props.notifId)}>x</button> */}
    </StyledNotification>
  );
};

export default SuccessNotification;
